import React, { useEffect, useState } from 'react';
import { useErrorInputs } from '../../../hooks/useErrorInputs';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useForm } from '../../../hooks/useForm';
import { useLocation } from 'react-router-dom';
import FormHelperText from '@mui/material/FormHelperText';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';

import { ActionButtons } from '../../../components/others/ActionButtons';
import { fetchServiceJson } from "../../../services/common.services";
import { insertContact } from '../../../services/contact.service';

export const CreateContact = ({ data, open, onClose }) => {
    const initialState = {
        id_company: '',
        name: '',
        origin: '',
        cellphone: '',
        email: ''
    };

    const [dto, handleInputChange, , setAllInfo] = useForm(initialState);

    const [errorInputs, , resetErrors, validForm] = useErrorInputs({});
    const [{ userSession }] = useDataAuth();
    const location = useLocation();
    const { config } = location.state || {};
    const [origin, setOrigin] = useState([]);

    const requiredFields = ['name', 'origin', 'email'];

    const handleSubmit = async () => {
        dto.id_company = data.id_company
        const isValid = validForm(requiredFields, dto);
        if (!isValid) {
            return;
        }
        const response = await insertContact(userSession.token, JSON.stringify({ ...dto, id_contact: config.data?.id ?? 0 }));
        handleClose(response.data?.[0].id ?? response.data?.[0].result);
    };

    const handleClose = (id_contact) => {
        setAllInfo(initialState);
        resetErrors();
        onClose({ id_contact });
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetchServiceJson('MENU-CONTACT', userSession.token);
                if (response.data && response.data.length > 0) {
                    const labels = response.data;
                    labels.forEach((item) => {
                        if (item.field === "origin") {
                            setOrigin(JSON.parse(item.value));
                        }
                    });
                }
            } catch (e) {
                console.error("Error fetching contact JSON:", e.message);
            }
        };
        fetchData();
    }, [userSession.token]);

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle>Información del Contacto</DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{ mt: 1 }}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField fullWidth required name="name" label="Nombre Completo" size="small"
                            value={dto.name}
                            error={Boolean(errorInputs.name?.isError)}
                            helperText={errorInputs.name?.messageError || ''}
                            onChange={handleInputChange}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <FormControl fullWidth required size="small"
                            error={Boolean(errorInputs.origin?.isError)}
                        >
                            <InputLabel id="origin-label">Origen</InputLabel>
                            <Select name="origin" labelId="origin-label"
                                value={dto.origin}
                                onChange={handleInputChange}
                            >
                                {origin.map((item) => (
                                    <MenuItem key={item.code} value={item.name}>
                                        {item.name}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errorInputs.origin?.isError && (
                                <FormHelperText>{errorInputs.origin.messageError}</FormHelperText>
                            )}
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField fullWidth name="cellphone" label="Celular" size="small" type="text"
                            value={dto.cellphone}
                            onChange={(e) => {
                                const newValue = e.target.value.replace(/\D/g, '').slice(0, 10);
                                handleInputChange({ target: { name: 'cellphone', value: newValue } });
                            }}
                            inputProps={{
                                maxLength: 10,
                                inputMode: 'numeric',
                                pattern: '[0-9]*',
                            }}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                        <TextField fullWidth required name="email" label="Email" size="small"
                            value={dto.email}
                            error={Boolean(errorInputs.email?.isError)}
                            helperText={errorInputs.email?.messageError || ''}
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>

            <DialogActions>
                <ActionButtons
                    onCancel={onClose}
                    onSubmit={handleSubmit}
                />
            </DialogActions>
        </Dialog>
    );
};
